import PlanService from "../../services";

export default {
  namespaced: true,
  state: () => ({
    plan: {
      current: {
        programs: [],
        urgencies: [],
      },
      archived: [],
    },
    loading: false,
    working: false,
  }),
  getters: {
    plan(state) {
      return state.plan;
    },
    currentPlan(state) {
      return state.plan.current;
    },
    urgentPlan(state) {
      return state.plan.current.urgencies;
    },
    programs(state) {
      // var x = [];
      // state.plan.current.programs.forEach((element) => {
      //   x.push(
      //     ...element.activities.map((el) => {
      //       return { ...el, program: element.name, program_id: element.id };
      //     })
      //   );
      // });
      // return x;
      return state.plan.current.programs;
    },
    archivedPlans(state) {
      return state.plan.archived;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
  },
  mutations: {
    setPlan(state, payload) {
      state.plan = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async fetchPlan({ commit }) {
      commit("setLoading", true);
      try {
        const data = await PlanService.fetchPlan();
        commit("setPlan", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },

    async addActivity({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        await PlanService.addActivity(payload);
        dispatch("fetchPlan");
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async updateActivity({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        await PlanService.updateActivity(payload);
        dispatch("fetchPlan");
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteActivity({ commit, dispatch }, payload) {
      commit("setWorking", true);

      try {
        await PlanService.deleteActivity(payload);
        dispatch("fetchPlan");
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
  },

  //   async updateService({ commit, dispatch }, payload) {
  //     commit("setWorking", true);
  //     await api
  //       .put(endpoints.NGO_SERVICES + "/" + payload.id, payload)
  //       .then((res) => {
  //         dispatch("fetchServicesAndClassifications");

  //         // if (res.status.ok) {
  //         //   this.$toast({
  //         //     component: ToastificationContent,
  //         //     props: {
  //         //       title: "Notification",
  //         //       icon: "BellIcon",
  //         //       text: "👋 Chocolate oat cake jelly oat cake candy jelly beans pastry.",
  //         //       variant,
  //         //     },
  //         //   });
  //         // }
  //       });
  //     commit("setWorking", false);
  //   },
  //   async addNewService({ commit, dispatch }, payload) {
  //     commit("setWorking", true);
  //     await api.post(endpoints.NGO_SERVICES, payload).then((res) => {
  //       dispatch("fetchServicesAndClassifications");
  //     });

  //     commit("setWorking", false);
  //   },

  //   async addNewClassification({ commit, dispatch }, payload) {
  //     commit("setWorking", true);
  //     await api.post(endpoints.NGO_CLASSIFICATIONS, payload).then((res) => {
  //       dispatch("fetchServicesAndClassifications");
  //     });
  //     commit("setWorking", false);
  //   },
  //   async deleteClassification({ commit, dispatch }, id) {
  //     commit("setLoading", true);
  //     await api.delete(endpoints.NGO_CLASSIFICATIONS_BY_ID(id)).then((res) => {
  //       dispatch("fetchServicesAndClassifications");
  //     });
  //     commit("setLoading", false);
  //   },
  //   async deleteService({ commit, dispatch }, id) {
  //     commit("setLoading", true);
  //     await api.delete(endpoints.NGO_SERVICE_BY_ID(id)).then((res) => {
  //       dispatch("fetchServicesAndClassifications");
  //     });
  //     commit("setLoading", false);
  //   },
  //   async updateClassification({ commit, dispatch }, payload) {
  //     commit("setWorking", true);
  //     await api
  //       .put(endpoints.NGO_CLASSIFICATIONS + "/" + payload.id, payload)
  //       .then((res) => {
  //         dispatch("fetchServicesAndClassifications");
  //       });
  //     commit("setWorking", false);
  //   },
  // },
};
